import './components.scss'
import Logo from '../../../assets/images/logo.png'
import { Icon } from '@iconify/react'
import { useNavigate } from 'react-router-dom'
import { useEffect, useState } from 'react'
import { get } from '../../../utils/Api'
import { useGlobalContext } from '../../../utils/Context'

function Sidebar({ page }: any) {
  const { toggleSidebar, profile } = useGlobalContext()
  const navigate = useNavigate()
  const [pendingKyc, setPendingKyc] = useState(0)

  const canReviewKyc =
    profile.role === 'super admin' || profile.role === 'customer service'

  // Pending-KYC badge: refresh on page change + every 60s
  useEffect(() => {
    if (!canReviewKyc) return
    const fetchCount = () => {
      get('kyc/admin/queue?status=pending_review&limit=1')
        .then((res: any) => {
          if (res.success) setPendingKyc(res.data.totalDocs || 0)
        })
        .catch(() => {})
    }
    fetchCount()
    const timer = setInterval(fetchCount, 60000)
    return () => clearInterval(timer)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [page])

  return (
    <div className={`sidebar ${toggleSidebar ? 'active' : ''}`}>
      <div className='sidebar-cover'>
        <div className='logo'>
          <img src={Logo} alt='qc express logo' />
        </div>
        <ul>
          <li
            className={`flex ${page === 'home' ? 'active' : ''}`}
            onClick={() => navigate('/admin/home')}
          >
            <div>
              <Icon icon='lucide:home' />
            </div>
            <p>Dashboard</p>
          </li>
          {profile.role !== 'agent' && (
            <li
              className={`flex ${page === 'analytics' ? 'active' : ''}`}
              onClick={() => navigate('/admin/analytics')}
            >
              <div>
                <Icon icon='simple-line-icons:chart' />
              </div>
              <p>Analytics</p>
            </li>
          )}
          <li
            className={`flex ${page === 'quick-quote' ? 'active' : ''}`}
            onClick={() => navigate('/admin/quick-quote')}
          >
            <div>
              <Icon icon='mdi:calculator-variant' />
            </div>
            <p>Quick Quote</p>
          </li>
          <div
            className={`rates ${
              page === 'bookings' ||
              page === 'all-bookings' ||
              page === 'drafts' ||
              page === 'over-drafts' ||
              page === 'cancelled-bookings' ||
              page === 'api-bookings' ||
              page === 'floating-bookings'
                ? 'active'
                : ''
            }`}
          >
            <div
              className='top'
              onClick={() => navigate('/admin/all-bookings')}
            >
              <div className='flex'>
                <div>
                  <Icon icon='icon-park-outline:tickets-two' />
                </div>
                <p>Bookings</p>
              </div>
            </div>
            <div className='bottom'>
              <p
                className={`${page === 'all-bookings' ? 'active' : ''}`}
                onClick={() => navigate('/admin/all-bookings')}
              >
                All Bookings
              </p>
              <p
                className={`${page === 'bookings' ? 'active' : ''}`}
                onClick={() => navigate('/admin/bookings')}
              >
                Platform Bookings
              </p>
              <p
                className={`${page === 'floating-bookings' ? 'active' : ''}`}
                onClick={() => navigate('/admin/floating-bookings')}
              >
                Floating Bookings
              </p>
              <p
                className={`${page === 'api-bookings' ? 'active' : ''}`}
                onClick={() => navigate('/admin/api-bookings')}
              >
                API Bookings
              </p>
              <p
                className={`${page === 'drafts' ? 'active' : ''}`}
                onClick={() => navigate('/admin/drafts')}
              >
                Drafts
              </p>
              <p
                className={`${page === 'over-drafts' ? 'active' : ''}`}
                onClick={() => navigate('/admin/over-drafts')}
              >
                Over-draft Bookings
              </p>
              <p
                className={`${page === 'cancelled-bookings' ? 'active' : ''}`}
                onClick={() => navigate('/admin/cancelled-bookings')}
              >
                Processed-cancelled Bookings
              </p>
            </div>
          </div>
          <div
            className={`rates ${
              page === 'businesses' ||
              page === 'onboarding-requests' ||
              page === 'business' ||
              page.includes('shipper')
                ? 'active'
                : ''
            }`}
          >
            <div className='top' onClick={() => navigate('/admin/businesses')}>
              <div className='flex'>
                <div>
                  <Icon icon='ion:business' />
                </div>
                <p>Businesses</p>
              </div>
            </div>
            <div className='bottom'>
              <p
                className={`${
                  page === 'businesses' || page === 'business' ? 'active' : ''
                }`}
                onClick={() => navigate('/admin/businesses')}
              >
                Businesses
              </p>
              {profile.role === 'super admin' && (
                <p
                  className={`${
                    page === 'onboarding-requests' ? 'active' : ''
                  }`}
                  onClick={() => navigate('/admin/onboarding-requests')}
                >
                  Onboarding requests
                </p>
              )}
              {/* IDs registered by Business API customers for their shippers.
                  Same pair as KYC review — the detail view shows the full ID
                  number. */}
              {(profile.role === 'super admin' ||
                profile.role === 'customer service') && (
                <p
                  className={`${page.includes('shipper') ? 'active' : ''}`}
                  onClick={() => navigate('/admin/shipper-ids')}
                >
                  Shipper IDs
                </p>
              )}
            </div>
          </div>
          {profile.role !== 'agent' && (
            <>
              <div
                className={`rates ${
                  page === 'transactions' || page === 'api-transactions'
                    ? 'active'
                    : ''
                }`}
              >
                <div
                  className='top'
                  onClick={() => navigate('/admin/transactions')}
                >
                  <div className='flex'>
                    <div>
                      <Icon icon='icon-park-outline:tickets-two' />
                    </div>
                    <p>Transactions</p>
                  </div>
                </div>
                <div className='bottom'>
                  <p
                    className={`${page === 'transactions' ? 'active' : ''}`}
                    onClick={() => navigate('/admin/transactions')}
                  >
                    Web transactions
                  </p>
                  <p
                    className={`${page === 'api-transactions' ? 'active' : ''}`}
                    onClick={() => navigate('/admin/api-transactions')}
                  >
                    API Transactions
                  </p>
                </div>
              </div>
            </>
          )}
          <li
            onClick={() => navigate('/admin/customers')}
            className={`flex ${page.includes('customer') ? 'active' : ''}`}
          >
            <div>
              <Icon icon='mynaui:users-group-solid' />
            </div>
            <p>Customers</p>
          </li>
          {(profile.role === 'super admin' ||
            profile.role === 'customer service') && (
            <li
              onClick={() => navigate('/admin/kyc-review')}
              className={`kyc-item flex ${page.includes('kyc') ? 'active' : ''}`}
            >
              <div>
                <Icon icon='mdi:shield-account-outline' />
              </div>
              <p>KYC Review</p>
              {pendingKyc > 0 && (
                <span className='kyc-count'>
                  {pendingKyc > 99 ? '99+' : pendingKyc}
                </span>
              )}
            </li>
          )}
          {/* Third-party sender IDs on platform bookings, with their
              intelligent check. Same pair as KYC review (API: 'master'). */}
          {(profile.role === 'super admin' ||
            profile.role === 'customer service') && (
            <li
              onClick={() => navigate('/admin/sender-id-checks')}
              className={`flex ${page === 'sender-id-checks' ? 'active' : ''}`}
            >
              <div>
                <Icon icon='mdi:card-account-details-outline' />
              </div>
              <p>Sender ID Checks</p>
            </li>
          )}
          {/* Creating and editing the tag taxonomy is super admin +
              customer service only — the same pair the API enforces. */}
          {(profile.role === 'super admin' ||
            profile.role === 'customer service') && (
            <li
              onClick={() => navigate('/admin/tags')}
              className={`flex ${page === 'tags' ? 'active' : ''}`}
            >
              <div>
                <Icon icon='mdi:tag-multiple-outline' />
              </div>
              <p>Shipment Tags</p>
            </li>
          )}
          <div
            className={`rates ${
              page === 'escalations' ||
              page === 'escalation' ||
              page === 'knowledge-base' ||
              page === 'knowledge-base-entry'
                ? 'active'
                : ''
            }`}
          >
            <div className='top' onClick={() => navigate('/admin/escalations')}>
              <div className='flex'>
                <div>
                  <Icon icon='mdi:headset' />
                </div>
                <p>QC Buddy</p>
              </div>
            </div>
            <div className='bottom'>
              <p
                className={`${page === 'escalations' ? 'active' : ''}`}
                onClick={() => navigate('/admin/escalations')}
              >
                All Escalations
              </p>
              <p
                className={`${page === 'knowledge-base' || page === 'knowledge-base-entry' ? 'active' : ''}`}
                onClick={() => navigate('/admin/knowledge-base')}
              >
                Knowledge Base
              </p>
            </div>
          </div>
          {profile.role !== 'agent' && (
            <li
              onClick={() => navigate('/admin/admins')}
              className={`flex ${page.includes('admin') ? 'active' : ''}`}
            >
              <div>
                <Icon icon='fa6-solid:users-gear' />
              </div>
              <p>Admins</p>
            </li>
          )}
          {(profile.role === 'manager' ||
            profile.role === 'customer service') && (
            <li
              onClick={() => navigate('/admin/user-rates')}
              className={`flex ${page === 'user-rates' ? 'active' : ''}`}
            >
              <div>
                <Icon icon='mdi:sack-percent' />
              </div>
              <p>Price Sheets</p>
            </li>
          )}
          {profile.role === 'super admin' && (
            <div
              className={`rates ${
                page.includes('rate') ||
                page.includes('portal-config') ||
                page === 'admin-logs' ||
                page === 'activity'
                  ? 'active'
                  : ''
              }`}
            >
              <div
                className='top'
                onClick={() => navigate('/admin/portal-config')}
              >
                <div className='flex'>
                  <div>
                    <Icon icon='ri:admin-fill' />
                  </div>
                  <p>Admin Services</p>
                </div>
              </div>
              <div className='bottom'>
                <p
                  className={`${page === 'portal-config' ? 'active' : ''}`}
                  onClick={() => navigate('/admin/portal-config')}
                >
                  Portal Config
                </p>
                <p
                  className={`${page === 'user-rates' ? 'active' : ''}`}
                  onClick={() => navigate('/admin/user-rates')}
                >
                  Zone Rates
                </p>
                <p
                  className={`${page === 'heavy-weight-rates' ? 'active' : ''}`}
                  onClick={() => navigate('/admin/heavy-weight-rates')}
                >
                  Heavy Weight Rates
                </p>
                <p
                  className={`${page === 'mid-weight-rates' ? 'active' : ''}`}
                  onClick={() => navigate('/admin/mid-weight-rates')}
                >
                  Mid Weight Rates
                </p>
                <p
                  className={`${page === 'admin-logs' ? 'active' : ''}`}
                  onClick={() => navigate('/admin/admin-logs')}
                >
                  Admin Logs
                </p>
                <p
                  className={`${page === 'activity' ? 'active' : ''}`}
                  onClick={() => navigate('/admin/activity')}
                >
                  System Activity
                </p>
                {/* <p
                  className={`${page === 'aggregators-rates' ? 'active' : ''}`}
                  onClick={() => navigate('/admin/aggregators-rates')}
                >
                  Aggregators Rates
                </p>
                <p
                  className={`${
                    page === 'super-aggregators-rates' ? 'active' : ''
                  }`}
                  onClick={() => navigate('/admin/super-aggregators-rates')}
                >
                  Super Aggregator Rates
                </p> */}
              </div>
            </div>
          )}
          {profile.role !== 'agent' && (
            <div
              className={`rates ${
                page === 'debt-batches' || page === 'grace-periods'
                  ? 'active'
                  : ''
              }`}
            >
              <div
                className='top'
                onClick={() => navigate('/admin/debt-batches')}
              >
                <div className='flex'>
                  <div>
                    <Icon icon='mdi:cash-multiple' />
                  </div>
                  <p>Debts</p>
                </div>
              </div>
              <div className='bottom'>
                <p
                  className={`${page === 'debt-batches' ? 'active' : ''}`}
                  onClick={() => navigate('/admin/debt-batches')}
                >
                  All Debt Batches
                </p>
                <p
                  className={`${page === 'grace-periods' ? 'active' : ''}`}
                  onClick={() => navigate('/admin/grace-periods')}
                >
                  Grace Periods
                </p>
              </div>
            </div>
          )}
          {profile.role !== 'agent' && (
            <div
              className={`rates ${
                page.includes('weight-discrepancy') ? 'active' : ''
              }`}
            >
              <div
                className='top'
                onClick={() => navigate('/admin/weight-discrepancy-analytics')}
              >
                <div className='flex'>
                  <div>
                    <Icon icon='mdi:weight-kilogram' />
                  </div>
                  <p>Weight Discrepancy</p>
                </div>
              </div>
              <div className='bottom'>
                <p
                  className={`${page === 'weight-discrepancy-analytics' ? 'active' : ''}`}
                  onClick={() =>
                    navigate('/admin/weight-discrepancy-analytics')
                  }
                >
                  Analytics
                </p>
                <p
                  className={`${page === 'weight-discrepancy' ? 'active' : ''}`}
                  onClick={() => navigate('/admin/weight-discrepancy')}
                >
                  Invoices
                </p>
              </div>
            </div>
          )}
          <li
            onClick={() => navigate('/admin/trackings')}
            className={`flex ${page.includes('tracking') ? 'active' : ''}`}
          >
            <div>
              <Icon icon='gis:location-poi' />
            </div>
            <p>Track Package</p>
          </li>
          {profile.role !== 'agent' && (
            <li
              onClick={() => navigate('/admin/notifications')}
              className={`flex ${
                page.includes('notification') ? 'active' : ''
              }`}
            >
              <div>
                <Icon icon='fa:bell' />
              </div>
              <p>Notifications</p>
            </li>
          )}
          <li
            onClick={() => {
              sessionStorage.clear()
              window.location.replace('/')
            }}
            className='flex'
          >
            <div>
              <Icon icon='line-md:log-out' />
            </div>
            <p>Log Out</p>
          </li>
        </ul>
      </div>
    </div>
  )
}

export default Sidebar
